import React from 'react'
import { useLocation } from 'react-router-dom'
import CreateRuleCommonPage from './CreateRuleCommonPage';
import usePermission from '../../utils/permissions';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export default function RulePreviewPage() {
    const { state } = useLocation();
    const permission = usePermission("/view-rules");
    const navigate = useNavigate();

    useEffect(() => {
        if (!permission?.READ) {
           navigate("/view-rules");
        }
    }, [permission]);
  return (
    <div>
      <CreateRuleCommonPage state={state} />
    </div>
  )
}
